/** Whether child names should be shown in list/card UI (only when there is more than one child). */
export function showChildLabels(childCount: number): boolean {
  return childCount > 1;
}
